<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 2.08325C9.62812 2.08325 7.29167 4.41971 7.29167 7.29158C7.29167 10.1635 9.62812 12.4999 12.5 12.4999C15.3719 12.4999 17.7083 10.1635 17.7083 7.29158C17.7083 4.41971 15.3719 2.08325 12.5 2.08325ZM12.5 10.4166C10.7771 10.4166 9.375 9.0145 9.375 7.29158C9.375 5.56867 10.7771 4.16659 12.5 4.16659C14.2229 4.16659 15.625 5.56867 15.625 7.29158C15.625 9.0145 14.2229 10.4166 12.5 10.4166ZM21.875 21.8749V20.8333C21.875 16.8135 18.6031 13.5416 14.5833 13.5416H10.4167C6.39583 13.5416 3.125 16.8135 3.125 20.8333V21.8749H5.20833V20.8333C5.20833 17.9614 7.54479 15.6249 10.4167 15.6249H14.5833C17.4552 15.6249 19.7917 17.9614 19.7917 20.8333V21.8749H21.875Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#999DA6',
      required: false,
    }
  }
};
</script>
